import { render, staticRenderFns } from "./term-direction.vue?vue&type=template&id=f844fa9c&"
import script from "./term-direction.vue?vue&type=script&lang=js&"
export * from "./term-direction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports